// Ajax cart JS for Drawer and Cart Page
class quickShop extends HTMLElement {
  constructor() {
    super();

    this.closeBy = this.querySelector('.close-quickshop');
    this.bindEvents();

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }

  /**
   * Escape Click event to close drawer when focused within Cart Drawer
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    this.querySelector('.close-quickshop').dispatchEvent(new Event('click'));
  }

  /**
   * bind click and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
   */
  bindEvents() {
    this.openeBy = document.querySelectorAll('[data-quick-shop]');
    this.openeBy.forEach(btn => btn.addEventListener('click', this.openQuickShop.bind(this)));
    //this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  /**
   * Re-bind events after page load or ajax call
   */
  updateEvents(){
    this.openeBy = document.querySelectorAll('[data-quick-shop]');
    if(this.openeBy) this.openeBy.forEach(btn => btn.addEventListener('click', (event)=>{
      event.stopImmediatePropagation();
      this.openQuickShop(event)
    }));
  }

  /**
   * Fetch Product data using handle
   * @param {*} handle 
   */
  async _loadQuickShop(handle){
    let requestURL = `/products/${handle}?sections=template-product-quickshop${this.quick_variant_id ? `&variant=${this.quick_variant_id}` : ''}`;
    const response = await fetch(requestURL);
    const quickShopData = await response.json();
    return quickShopData['template-product-quickshop'];
  }

  /**
   * Open QuickShop modal and add focus to modal container
   *
   * @param {event} Event instance
   */
  openQuickShop(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const _this = event.currentTarget;
    const handle = _this.dataset.handle;
    if(_this.getAttribute('data-quick-view-variant-id')){
      this.quick_variant_id = _this.getAttribute('data-quick-view-variant-id')
    }
    if(!handle) return;
    window.updae_line_index = _this.getAttribute('data-line-index') ? parseInt(_this.getAttribute('data-line-index')) : 0;
    
    this._loadQuickShop(handle).then(quickShopData => {
      let _this = document.querySelector('quick-shop');
      _this.innerHTML = quickShopData;
      _this.querySelector('.modal').classList.add('open');
      siteOverlay.prototype.showOverlay();

      if(_this.querySelector('.product-title')) Utility.forceFocus(_this.querySelector('.product-title'));
      _this.closeBy = _this.querySelector('.close-quickshop');
      if(_this.closeBy) _this.closeBy.addEventListener('click', _this.closeQuickShop.bind(_this));
      Utility.trapFocus(_this, _this.closeBy);

      if(event){
        _this.setAttribute('aria-expanded', true);
      }
      if(window.updae_line_index && window.globalVariables.template == 'cart'){
        let submitButton = document.querySelector('quick-shop [type="submit"]:not([disabled])');
        submitButton?.querySelector('[data-add-to-cart-text]').classList.add('d-none');
        submitButton?.querySelector('[data-update-text]').classList.remove('d-none');
      }
      // setTimeout(function() {HulkappWishlist.init();}, 800);
    });
    
  }

  /**
   * Open QuickShop and Remove focus from modal container
   *
   * @param {event} Event instance
   */
  closeQuickShop(event, elementToFocus = false) {
    if (event !== undefined) {
      event.preventDefault();
      this.innerHTML = '';
      quickShopSlider = null;
      
      siteOverlay.prototype.hideOverlay();
      let openByEle = document.querySelector('[data-quick-shop][aria-expanded="true"]');
      openByEle?.setAttribute('aria-expanded', false);
      Utility.removeTrapFocus(elementToFocus);
      Utility.forceFocus(openByEle);
      window.updae_line_index = 0;
    }
  }
}
customElements.define("quick-shop", quickShop);
  
